import styled from 'styled-components';
export const MobileAppContainer = styled.div `
  margin-top: 20px;
  display: flex;
  gap: 16px;
`;
export const MobileAppLink = styled.a `
  display: block;
`;
export const MobileAppImage = styled.img `
  display: block;
  height: 48px;
  width: auto;
`;
